"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS = exports.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD = exports.SET_WAITLIST_OPTIN_STATUS_FIELD = exports.RESET_LOCATION_FILTER = exports.CONDITIONAL_GX_QUESTION_ANSWERED = exports.CONDITIONAL_GX_PASSED = exports.GX_V1_FAILED = exports.GX_PASSED = exports.GX_QUESTION_ANSWERED = exports.CAPTCHA_RESET = exports.CAPTCHA_ERROR = exports.CAPTCHA_VERIFIED = exports.CAPTCHA_CANCELLED = exports.FORM_UPDATE = exports.FORM_CHANGE = exports.SET_FILTERS_ON_PARENT = exports.UPDATE_PARENT = exports.REBOOK = exports.REBOOK_DIRECT = exports.BOOK_APPT = exports.LOAD_MORE = exports.INITIALIZED = exports.JUMP_TO_DATE = exports.CLEAR_ALL_FILTERS = exports.SET_ALL_FILTERS = exports.CLEAR_FILTERS = exports.SET_LOCAL_FILTER = exports.UPDATE_APPT_QUERY = exports.SELECT_PATIENT = exports.SELECT_APPOINTMENT = exports.SET_APPT_PURPOSE = exports.SET_PATIENT_REL = exports.GO_BACK = exports.NEXT = exports.INIT = void 0;
exports.INIT = '@action/INIT';
exports.NEXT = '@action/NEXT';
exports.GO_BACK = '@action/GO_BACK';
exports.SET_PATIENT_REL = '@action/SET_PATIENT_REL';
exports.SET_APPT_PURPOSE = '@action/SET_APPT_PURPOSE';
exports.SELECT_APPOINTMENT = '@action/SELECT_APPOINTMENT';
exports.SELECT_PATIENT = '@action/SELECT_PATIENT';
exports.UPDATE_APPT_QUERY = '@action/UPDATE_APPT_QUERY';
exports.SET_LOCAL_FILTER = '@action/SET_LOCAL_FILTER';
exports.CLEAR_FILTERS = '@action/CLEAR_FILTERS';
exports.SET_ALL_FILTERS = '@action/SET_ALL_FILTERS';
exports.CLEAR_ALL_FILTERS = '@action/CLEAR_ALL_FILTERS';
exports.JUMP_TO_DATE = '@action/JUMP_TO_DATE';
exports.INITIALIZED = '@action/INITIALIZED';
exports.LOAD_MORE = '@action/LOAD_MORE';
exports.BOOK_APPT = '@action/BOOK_APPT';
exports.REBOOK_DIRECT = '@action/REBOOK_DIRECT';
exports.REBOOK = '@action/REBOOK';
exports.UPDATE_PARENT = '@actions/UPDATE_PARENT';
exports.SET_FILTERS_ON_PARENT = '@actions/SET_FILTERS_ON_PARENT';
exports.FORM_CHANGE = '@actions/FORM_CHANGE';
exports.FORM_UPDATE = '@actions/FORM_UPDATE';
exports.CAPTCHA_CANCELLED = '@actions/CAPTCHA_CANCELLED';
exports.CAPTCHA_VERIFIED = '@actions/CAPTCHA_VERIFIED';
exports.CAPTCHA_ERROR = '@actions/CAPTCHA_ERROR';
exports.CAPTCHA_RESET = '@actions/CAPTCHA_RESET';
exports.GX_QUESTION_ANSWERED = '@action/GX_QUESTION_ANSWERED';
exports.GX_PASSED = '@action/GX_PASSED';
exports.GX_V1_FAILED = '@actions/GX_V1_FAILED';
exports.CONDITIONAL_GX_PASSED = '@actions/CONDITIONAL_GX_PASSED';
exports.CONDITIONAL_GX_QUESTION_ANSWERED = '@actions/CONDITIONAL_GX_QUESTION_ANSWERED';
exports.RESET_LOCATION_FILTER = '@actions/RESET_LOCATION_FILTER';
exports.SET_WAITLIST_OPTIN_STATUS_FIELD = '@actions/SET_WAITLIST_OPTIN_STATUS_FIELD';
exports.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD = '@actions/UPDATE_WAITLIST_MOBILE_NUMBER_FIELD';
exports.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS = '@actions/UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS';
//# sourceMappingURL=Actions.js.map